'use client';

import Script from 'next/script';

export default function HotJar() {
  return (
    <>
      {/* lazyOnload defers Hotjar to requestIdleCallback so it never
          competes with critical resources during initial render. Hotjar
          recordings still work; we only need the script alive after the
          page is settled. */}
      <Script id="hotjar-script" strategy="lazyOnload">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:6536580,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
    </>
  );
}